import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

interface Int_HttpHeaders {
  "X-CSCAPI-KEY": string;
}

@Injectable({
  providedIn: "root",
})
export class CountryStateCityService {
  private readonly http = inject(HttpClient);

  constructor() {
    this.httpHeaders = {
      "X-CSCAPI-KEY": this.API_KEY,
    };
  }

  readonly rootUrl: string = "https://api.countrystatecity.in";
  private readonly API_KEY: string = "emhFN2NBM1RWT2FwOWxidnpuMzBscHlLOWl4Y1E2eTVTOGpkdDNaZA==";
  private httpHeaders: Int_HttpHeaders | any = {
    "X-CSCAPI-KEY": "",
  };

  // SOURCE : https://countrystatecity.in/docs/

  getAllCountries() {
    return this.http.get(`${this.rootUrl}/v1/countries`, { headers: this.httpHeaders });
  }

  getCountryDetails(ISO2: string) {
    return this.http.get(`${this.rootUrl}/v1/countries/${ISO2}`, { headers: this.httpHeaders });
  }

  getAllStates() {
    return this.http.get(`${this.rootUrl}/v1/states`, { headers: this.httpHeaders });
  }

  getStatesByCountry(ISO2: string) {
    return this.http.get(`${this.rootUrl}/v1/countries/${ISO2}/states`, { headers: this.httpHeaders });
  }

  getStateDetails(ISO2: string, stateISO2: string) {
    return this.http.get(`${this.rootUrl}/v1/countries/${ISO2}/states/${stateISO2}`, { headers: this.httpHeaders });
  }

  getCityByCountryAndState(ISO2: string, stateISO2: string) {
    return this.http.get(`${this.rootUrl}/v1/countries/${ISO2}/states/${stateISO2}/cities`, { headers: this.httpHeaders });
  }

  getCityByCountry(ISO2: string) {
    return this.http.get(`${this.rootUrl}/v1/countries/${ISO2}/cities`, { headers: this.httpHeaders });
  }
}
